export default __webpack_public_path__ + "static/media/t568a.dbda1627.jpg";